export default {
  'CalendarScreen.noEvent': {
    en: 'No scheduled event for this date.',
    fr: 'Aucun événement prévu pour cette date.',
  },
};
